import { render, staticRenderFns } from "./cardActivity.vue?vue&type=template&id=096b2fac&scoped=true"
import script from "./cardActivity.vue?vue&type=script&lang=js"
export * from "./cardActivity.vue?vue&type=script&lang=js"
import style0 from "./cardActivity.vue?vue&type=style&index=0&id=096b2fac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096b2fac",
  null
  
)

export default component.exports